
export default () => {
    const MOBILE_MENU_BREAKPOINT = 1279;

    function mobileMenuItemClick (e) {
        const isMobileMenu = window.matchMedia('(max-width: ' + MOBILE_MENU_BREAKPOINT + 'px)').matches;

        if (!isMobileMenu) {
            return;
        }

        e.preventDefault();

        for (let i = this.parentNode.parentNode.children.length - 1; i >= 0; i--) {
            if (this.parentNode.parentNode.children[i] === this.parentNode) {
                this.parentNode.classList.toggle('lvl-1-open');
                continue;
            }
            this.parentNode.parentNode.children[i].classList.remove('lvl-1-open');
        }

    }

    const topLevelMenuItems = document.querySelectorAll('.e-header .menu-item-has-children > .main-menu-item-heading');
    if (topLevelMenuItems.length) {
        for (let i = topLevelMenuItems.length - 1; i >= 0; i--) {
            topLevelMenuItems[i].addEventListener('click', mobileMenuItemClick);
        }
    }
}
